<template>
	<div class="main">
		<hwk-header></hwk-header>
		<div class="warp order-list">
			<hwk-left type="myShop"></hwk-left>
			<div class="o-l-r">
				<div class="search flex">
					<div class="sl">共<span>{{total}}</span>个店铺</div>
					<div class="sr2 flex pointer" @click="add">
						<img src="@/assets/add3.png" alt="" /><span>添加店铺</span>
					</div>
				</div>
				<div class="hwk-shop-list">
					<table classs="table-shop">
						<tr class="top">
							<td class="td1" @click="changeAll">
								<img src="@/assets/f2.png" alt="" v-if="checked" />
								<img src="@/assets/f1.png" alt="" v-else />
							</td>
							<td class="td2">ID</td>
							<td class="td3">店铺名称</td>
							<td class="td4">出售平台</td>
							<td class="td5">创建时间</td>
							<td class="td6">操作</td>
						</tr>
						<tr v-for="(item,index) in list" :key="index">
							<td class="td1" @click="changeChecked(item,index)">

								<img src="@/assets/f2.png" alt="" v-if="item.checked" />
								<img src="@/assets/f1.png" alt="" v-else />
							</td>
							<td>{{item.id}}</td>
							<td>{{item.name}}</td>
							<td>{{item.source_item && item.source_item.name}}</td>
							<td>{{$timeFormat(item.updatetime||item.createtime,'yyyy-mm-dd hh:MM:ss')}}</td>
							<td>
								<div class="operate flex">
									<div class="i flex" @click="edit(item)">
										<img src="@/assets/edit.png" alt="" /><span>修改</span>
									</div>
									<div class="i flex" @click="del(item)">
										<img src="@/assets/del.png" alt="" /><span>删除</span>
									</div>
								</div>
							</td>
						</tr>
					</table>
				</div>
				<div class="pagination">
					<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
						:page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<navigation></navigation>
		<el-dialog :title="title" :visible.sync="addShow" width="410px">
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="店铺名称">
					<el-input v-model="form.name" placeholder="请输入店铺名称"></el-input>
				</el-form-item>
				<el-form-item label="出售平台">
					<el-select style="width: 100%;" v-model="form.source_id" placeholder="请选择">
						<el-option :label="item.name" :value="item.id" v-for="(item,index) in slist"
							:key="index"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import hwkHeader from './hwk-header.vue'
	import hwkLeft from './hwk-left.vue'
	import navigation from './navigation.vue'
	export default {
		components: {
			hwkHeader,
			navigation,
			hwkLeft
		},
		data() {
			return {
				addShow: false,
				filterShow: false,
				leftType: 'orderList',
				form: {
					id: "",
					name: "",
					source_id: ""
				},
				list: [],
				pageSize: 10,
				checked: false,
				currentPage: 1,
				name: "",
				total: 0,
				title: "添加店铺",
				slist: [],
				fromBuy: false
			};
		},
		created() {
			this.getlist();
			this.getsourcelist()
			if (this.$route.query.addShow == 1) {
				this.fromBuy = true
				this.addShow = true
			}
		},
		watch: {
			// checked: {
			// 	handler(newVal, oldVal) {
			// 		this.list.forEach(item => item.checked = newVal)
			// 	},
			// 	deep: true
			// }
		},
		methods: {
			changeChecked(item, index) {
				item.checked = !item.checked
				this.checked = this.list.every(item => item.checked)
				this.$forceUpdate()
			},
			changeAll() {
				this.checked = !this.checked
				this.list.forEach(item => item.checked = this.checked)
			},
			changeCheck() {
				this.checked = this.list.every(item => item.checked)
				this.$forceUpdate()
			},
			del(item) {
				this.$confirm('此操作将删除该店铺, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('api/user_shop/del', {
						id: item.id
					}).then(res => {
						console.log(res)
						if (res.code == 1) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getlist()
						} else {
							this.$message({
								message: res.msg,
								type: 'error'
							});
						}
					});

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			add() {
				this.title = '添加店铺'
				this.addShow = true
			},
			edit(item) {
				this.form = item
				this.title = '修改店铺'
				this.addShow = true
				console.log(this.form, 'this.form')
			},
			submit() {
				if (!this.form.name) {
					this.$message({
						message: '名称不能为空',
						type: 'warning'
					});
					return
				}
				// if (!this.form.region) {
				// 	this.$message({
				// 		message: '请选择平台',
				// 		type: 'warning'
				// 	});
				// 	return
				// }
				let url = this.form.id ? "api/user_shop/edit" : "/api/user_shop/add"
				this.$http.post(url, {
					id: this.form.id,
					name: this.form.name,
					// image: this.form.image,
					source_id: this.form.source_id
				}).then(res => {
					console.log(res)
					if (res.code == 1) {
						this.addShow = false
						this.form = {
							id: "",
							name: "",
							region: ""
						}
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.getlist()
						if (this.fromBuy) {
							this.$router.push({
								path: "/carAddress",
								query: {
									from: 'myShop'
								}
							});
						}
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
				});

			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.currentPage = val
				this.getlist()
			},
			changeNav(index) {
				if (this.navindex != index) {
					this.navindex = index
				}
			},
			pageTo(url) {
				this.$router.push({
					path: url,
				});
			},
			toDetails(id) {
				// this.$router.push({
				// 	path: `/details/${id}`
				// });
				// this.$router.push({
				// 	name: "details",
				// 	params: {
				// 		id: id
				// 	}
				// });
				this.$router.push({
					path: "/details",
					query: {
						id: id
					}
				});
			},
			getlist() {
				this.$http.get('/api/user_shop/index', {
					params: {
						page: this.currentPage,
						limit: this.pageSize,
						name: this.name
					}

				}).then(res => {
					console.log(res)
					this.list = res.data.data
					this.list.forEach(item => item.checked = false)
					this.total = res.data.total
				});

			},
			getsourcelist() {
				this.$http.get('/api/user_shop/source_list', {

				}).then(res => {
					console.log(res)
					this.slist = res.data

				});
			},
		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;

	.hwk-shop-list {
		margin-top: 20px;
		width: 100%;

		table {
			width: 100%;
			border-collapse: collapse;
			border-spacing: 0px;

			.top {
				height: 40px;
				background: #F7F9FA;
				border-radius: 6px 6px 6px 6px;

				td {
					font-size: 14px;
					color: @color1;
					font-weight: 500;
				}

				.td1 {
					width: 40px;
					text-align: center;

					img {
						width: 16px;
						height: 16px;
					}
				}

				.td2 {
					width: 80px;
				}

				.td3 {}

				.td4 {
					width: 270px;
				}

				.td5 {
					width: 200px;
				}

				.td6 {
					width: 150px;
				}
			}

			tr {
				.td1 {
					text-align: center;

					img {
						width: 16px;
						height: 16px;
					}
				}

				td {
					height: 40px;
					line-height: 40px;
					font-size: 15px;
					color: #8C8C8C;
					border-bottom: 1px solid #F5F5F5;

					.operate {
						align-items: center;

						.i {
							margin-left: 10px;
							cursor: pointer;

							img {
								width: 15px;
								height: 15px;
							}

							span {
								font-size: 14px;
								color: @color2;
								margin-left: 5px;
							}
						}
					}
				}


			}
		}
	}

	.table-form {

		td {
			width: 33.33%;

			.el-form-item {
				margin-bottom: 0 !important;
			}
		}
	}

	.order-list {
		background-color: #fff;
		padding: 20px;
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		border-radius: 10px;

		.o-l-r {
			flex: 1;
			width: 1px;
			margin-left: 20px;

			.search {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 20px;

				.sr2 {
					width: 100px;
					height: 34px;
					background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
					border-radius: 30px;
					line-height: 34px;
					align-items: center;
					justify-content: center;
					text-align: center;

					img {
						width: 14px;
						height: 14px;
					}

					span {
						font-size: 14px;
						color: #fff;
						margin-left: 5px;
					}
				}

				.sl {

					font-size: 14px;
					color: @color1;
					text-align: left;

					span {
						color: @color2;
						padding: 0 5px;
					}
				}

			}

		}


	}

	.pagination {
		padding: 20px 0;
	}

	.footer-btn {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		text-align: center;

		.btn1 {
			width: 100px;
			height: 34px;
			background: #FFFFFF;
			border-radius: 20px 20px 20px 20px;
			border: 1px solid #D9D9D9;
			color: #868E99;
			font-size: 14px;
			line-height: 34px;
		}

		.btn2 {
			width: 100px;
			height: 34px;
			line-height: 34px;
			background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
			border-radius: 30px 30px 30px 30px;
			color: #fff;
			font-size: 14px;
			margin-left: 20px;
		}
	}
</style>